import { Component, ContentChild, EventEmitter, HostBinding, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
    @ContentChild('error', {static: true}) errorTmpl: TemplateRef<any>;

    @Input() message = '';
    @Input() backgroundColor = '#000000';
    @Input() icon = 'send';
    @Input() dismissible = false;

    @HostBinding('class.responsive') @Input() responsive = false;
    @HostBinding('class') @Input() type: 'info' | 'warning' | 'error' | 'custom' = 'info';

    @Output() dismiss = new EventEmitter<void>();

    @HostBinding('style.background-color') get hostBackgroundColor() {
        if (this.type === 'custom') {
            return this.backgroundColor;
        }
    }

    constructor() {
    }

    ngOnInit() {
    }

    onDismiss(event: MouseEvent): void {
        event.stopPropagation();
        this.dismiss.emit();
    }
}
